import { Flex, SearchFilterTag, theme } from '@/components';
import type {
  AnalysisSearchFormType,
  AnalysisSearchKeys,
} from '@/features/search/_models/analysis-search';
import { t } from '@/i18n';
import {
  AggregationTargetTypeLabelModifier,
  AggregationTypeLabelModifier,
  AnalysisAxisLabelModifier,
} from '@/utils/enum';
import { type FC, useMemo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

type FieldKey = (typeof AnalysisSearchKeys)[number];

export const AggregationTags: FC = () => {
  const { token } = theme.useToken();
  const { control, setValue } = useFormContext<AnalysisSearchFormType>();
  const aggregationType = useWatch({ control, name: 'aggregationType' });
  const aggregationTargetType = useWatch({
    control,
    name: 'aggregationTargetType',
  });
  const analysisAxis = useWatch({ control, name: 'analysisAxis' });
  const value = useMemo<{ key: FieldKey; value: string }[]>(() => {
    return [
      ...(aggregationTargetType
        ? [
            {
              key: 'aggregationType' as const,
              value: `${t('aggregation-type')}: ${AggregationTypeLabelModifier[aggregationType]}`,
            },
          ]
        : []),
      ...(aggregationTargetType
        ? [
            {
              key: 'aggregationTargetType' as const,
              value: `${t('aggregation-target')}: ${AggregationTargetTypeLabelModifier[aggregationTargetType]}`,
            },
          ]
        : []),
      ...(analysisAxis && analysisAxis !== 'year'
        ? [
            {
              key: 'analysisAxis' as const,
              value: `${t('axis-of-analysis')}: ${AnalysisAxisLabelModifier[analysisAxis]}`,
            },
          ]
        : []),
    ];
  }, [aggregationType, aggregationTargetType, analysisAxis]);

  return (
    <Flex
      gap={8}
      style={{ background: token.colorBgLayout, padding: 5 }}
      wrap="wrap"
    >
      {value.map((v) => (
        <SearchFilterTag
          closable={v.key === 'analysisAxis'}
          onClose={() => {
            setValue(v.key, null as any);
          }}
          key={v.key}
          label={v.value}
        />
      ))}
    </Flex>
  );
};
